//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { iosInput, htmlToText } from '@/tools/index.js'
import { mapGetters } from 'vuex'
import dropdownCheckbox from './dropdown_checkbox'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data () {
    return {
      multipleSelectValue: [],
      multipleSelectText: '',
      rule: {
        custom: {
          multipleSelectText: {
            required: () => '请选择一个选项',
          }
        }
      }
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    this.$validator.localize('zh_CN', this.rule);
    //已答的题挂上答案
    if (this.question.v_answer) {
      //选中选项
      const ids = this.question.v_answer.currentValue || []
      this.multipleSelectText = this.findMultipleSelectText(ids)
      this.multipleSelectValue = ids
    }
  },
  computed: {
    ...mapGetters(['questionnaireList'])
  },
  watch: {
    multipleSelectValue (n ,o) {
      const param = {
        index: this.index,
        v_answered: !!n.length
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer
        })
        // 取消回调
        this.$emit('onSelectCancel')
        return
      }
      v_answer = this.getValue()
      console.log(v_answer);
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer
      })
      //把当前选中的选项传给父组件判断子题是否显示
      this.$emit('onSelectChange')    
    }
    
  },
  methods: {
    getCheckboxValidate (question) {
      var rules = []
      if (question.required) {
        rules.push('required')
      }
      if (question.selectRangeMin) {
        rules.push(`selectRangeMin:${question.selectRangeMin},${question.selectRangeMax}`)
      }
      if (question.selectRangeMax) {
        rules.push(`selectRangeMax:${question.selectRangeMin},${question.selectRangeMax}`)
      }
      console.log(rules.join('|'));
      return rules.join('|')
    },
    onBlur () {
      iosInput()
    },
    getValue (value) {
      const options = []
      this.multipleSelectValue.forEach((currentId) => {
        let checkedOption = this.question.options.find((item) => {
          return item.tenantId == currentId
        })
        options.push({
          tenantId: checkedOption.tenantId
        })
      })
      return {
				tenantId: this.question.tenantId,
				type: 'dropdown_multiple',
				options: options,
				currentValue: this.multipleSelectValue
			}
    },
    validate () {
      return this.$validator.validateAll()
    },
    open () {
      let self = this
      let pop = new this.$Popup(dropdownCheckbox, {
        position: 'bottom',
        size: '310px',
        isMask: true,
        isMaskClose: true,
        transition: true,
        question: this.question,
        onChoose(value) {
          self.multipleSelectValue = value
          self.multipleSelectText = self.findMultipleSelectText(value)
        }
      })
    },
    findMultipleSelectText (ids) {
      const options = []
      ids.forEach((currentId) => {
        let checkedOption = this.question.options.find((item) => {
          return item.tenantId == currentId
        })
        options.push(checkedOption.text)
      })
      let str = options.join('\n\n')
      return htmlToText(str)
    }
  }
}
